import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component, PropTypes } from 'react';
import * as styles from './BigText.scss';

var BigText = /*#__PURE__*/function (_Component) {
  _inherits(BigText, _Component);

  var _super = _createSuper(BigText);

  function BigText() {
    _classCallCheck(this, BigText);

    return _super.apply(this, arguments);
  }

  _createClass(BigText, [{
    key: "render",
    value: function render() {
      // paired with the default prop, this makes sure that 0 values are passed in and that the number can also be omitted
      var number = this.props.number.toString();
      return /*#__PURE__*/React.createElement("div", {
        className: styles.wrap,
        style: this.props.style
      }, number !== '0909090909' && /*#__PURE__*/React.createElement("span", {
        className: styles.number,
        style: this.props.numberStyle
      }, number), this.props.text && /*#__PURE__*/React.createElement("span", {
        className: styles.text,
        style: this.props.textStyle
      }, this.props.text));
    }
  }]);

  return BigText;
}(Component);

_defineProperty(BigText, "defaultProps", {
  number: '0909090909'
});

export { BigText as default };